// src/ChatGPTAccountabilityBuddy.js
import React, { useState } from 'react';
import axiosInstance from './server'; // Adjust the import path to point to the axiosInstance.js file

import { Box, Typography, TextField, Button, ListItem, List } from '@mui/material';

const ChatGPTAccountabilityBuddy = () => {
  const [userMessage, setUserMessage] = useState('');
  const [chatHistory, setChatHistory] = useState([]);

  const sendMessage = async (e) => {
    e.preventDefault();
    if (userMessage.trim() === '') return;

    setChatHistory((prev) => [...prev, { message: userMessage, sender: 'user' }]);
    setUserMessage('');

    try {

    const response = await axiosInstance.post('/', {
      prompt: `User: ${userMessage}\nChatGPT:`,
      max_tokens: 200,
      n: 1,
      stop: null,
      temperature: 0.8,
      model: 'gpt-3.5-turbo'
    });

    const gptResponse = response.data.choices[0].text;
    setChatHistory((prev) => [...prev, { message: gptResponse, sender: 'chatGPT' }]);
    } catch (error) {
        console.error('Error fetching response from ChatGPT:', error);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        backgroundColor: '#f5f5f5',
        borderRadius: 1,
        padding: 2,
      }}
    >
      <Typography variant="h6" component="h3" gutterBottom>
        What is your quest?
      </Typography>
      <List
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
          marginBottom: 2,
        }}
      >
        {chatHistory.map((msg, idx) => (
          <ListItem key={idx} alignItems="flex-start">
            <Typography
              variant="body1"
              component="p"
              sx={{
                color: msg.sender === 'user' ? 'blue' : 'green',
                marginBottom: 1,
              }}
            >
              {msg.sender}: {msg.message}
            </Typography>
          </ListItem>
        ))}
      </List>
      <form onSubmit={sendMessage}>
        <TextField
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          value={userMessage}
          onChange={(e) => setUserMessage(e.target.value)}
          placeholder="Type your task and assignment here, as much detail as possible. Then press send to break it down into smaller tasks with priority."
          sx={{ marginBottom: 1 }}
        />
        <Button variant="contained" type="submit">
          Send
        </Button>
      </form>
    </Box>
  );
};

export default ChatGPTAccountabilityBuddy;
